import React, {useRef, useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from '../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  },
  textFieldUppercase: {
    textTransform: 'uppercase'
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

var defaultFilter = {
  idPartner: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false
};

export default function MedicalRecords(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);
  const [selectedItemCheckedOptions, setSelectedItemCheckedOptions] = useState([]);

  const prevData = usePrevious({selectedItem});

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  const emptyItem = {
    id: '',
    idService: '',
    serviceType: '',
    carCategories: '',
    idPerson: '',
    person: '',
    address: '',
    phone: '',
    description: '',
    existingPerson: null,
    personDetails: {
      surname: '',
      name: '',
      cnp: '',
      birthIdCounty: '',
      birthCity: '',
      addressIdCounty: '',
      addressCity: '',
      addressStreet: '',
      addressNumber: '',
      addressBuilding: '',
      addressStaircase: '',
      addressFloor: '',
      addressApartment: '',
      identityCardType: 'CI',
      identityCardSerial: '',
      identityCardNumber: '',
      identityCardIssuedBy: '',
      identityCardIssuedAt: '',
      phone: '',
      email: ''
    }
  };

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerMedicalRecords')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setData(response.data);

          if (props.match.params.op === 'Add') {
            setSelectedItem(emptyItem);
            setSelectedItemOperation('editMedicalRecord');
          }
        }

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setFilter({...filter, idPartner: Boolean(props.user.idPartner) ? props.user.idPartner : '0'});
  }, [props.user]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const handleSelectedItemChange = (property = null) => e => {
    if (property)
      setSelectedItem({
        ...selectedItem,
        [property]: {...selectedItem[property], [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''}
      });
    else
      setSelectedItem({
        ...selectedItem,
        [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
      });
  };

  useEffect(() => {
    if (selectedItemOperation === null || !selectedItem || !prevData || (prevData && prevData.selectedItem && JSON.stringify(prevData.selectedItem.idService) !== JSON.stringify(selectedItem.idService))) {
      setSelectedItemCheckedOptions([]);
      return;
    }

    var warning = null;
    switch (selectedItemOperation) {
      case 'editMedicalRecord':
        warning = warning === null ? typeof selectedItem.existingPerson === 'undefined' && !RegExp(/^07\d{8}$/, 'gmi').test(selectedItem.phone) ? 'Nu ati introdus un numar de telefon valid (de forma 07xx)' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === null && !RegExp(/^\d{13}$/, 'gmi').test(selectedItem.personDetails.cnp) ? 'Nu ati introdus un CNP valid' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === true && !RegExp(/^07\d{8}$/, 'gmi').test(selectedItem.phone) ? 'Nu ati introdus un numar de telefon valid (de forma 07xx)' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.surname.length < 3 ? 'Numele persoanei este prea scurt' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.name.length < 3 ? 'Prenumele persoanei este prea scurt' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.birthIdCounty === '' ? 'Nu ati selectat judetul nasterii' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.birthCity.length < 3 ? 'Localitatea nasterii este prea scurta' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.addressIdCounty === '' ? 'Nu ati selectat judetul de domiciliu' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.addressCity.length < 3 ? 'Localitatea de domiciliu este prea scurta' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.addressStreet.length < 3 ? 'Strada de domiciliu este prea scurta' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.addressNumber === '' ? 'Nu ati introdus un numar de strada' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.identityCardType === '' ? 'Nu ati selectat tipul actului de identitate' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.identityCardSerial === '' ? 'Nu ati completat seria actului de identitate' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.identityCardNumber === '' ? 'Nu ati completat numarul actului de identitate' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.identityCardIssuedBy === '' ? 'Nu ati completat emitentul actului de identitate' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && selectedItem.personDetails.identityCardIssuedAt === '' ? 'Nu ati selectat data actului de identitate' : null : warning;
        warning = warning === null ? selectedItem.existingPerson === false && !RegExp(/^07\d{8}$/, 'gmi').test(selectedItem.personDetails.phone) ? 'Nu ati introdus un numar de telefon valid (de forma 07xx)' : null : warning;
        warning = warning === null ? !Boolean(selectedItem.idService) ? 'Nu ati selectat nici un serviciu' : null : warning;
        warning = warning === null ? !Boolean(selectedItem.serviceType) ? 'Nu ati selectat pentru ce este necesara fisa' : null : warning;
        warning = warning === null ? !Boolean(selectedItemCheckedOptions.length) ? 'Nu ati selectat nici o categorie auto' : null : warning;
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation, selectedItemCheckedOptions.length]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selectedItemOperation === 'editMedicalRecord')
      setSelectedItemCheckedOptions(selectedItem.carCategories.split(','));
  }, [selectedItemOperation]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleItemCheckedOptionsToggle = value => () => {
    const currentIndex = selectedItemCheckedOptions.indexOf(value);
    const newChecked = [...selectedItemCheckedOptions];

    if (currentIndex === -1)
      newChecked.push(value);
    else
      newChecked.splice(currentIndex, 1);

    setSelectedItemCheckedOptions(newChecked);
  };

  const filterData = item => true
      && (filter.idPartner === '0' || item.idPartner === filter.idPartner)
      && (!!~item.person.toLowerCase().indexOf(filter.text.toLowerCase()))
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem(item);
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleSearchPerson = () => {
    ajax('getPersonByCnp', {
      cnp: selectedItem.personDetails.cnp
    })
      .then(response => {
        if (response.data.person)
          setSelectedItem({
            ...selectedItem,
            idPerson: response.data.person.id,
            person: response.data.person.person,
            address: response.data.person.address,
            phone: response.data.person.phone,
            existingPerson: true
          });
        else
          setSelectedItem({
            ...selectedItem, idPerson: '',
            existingPerson: false
          });
      });
  };

  const handleEditMedicalRecord = () => {
    setIsLoaded(false);
    ajax('resellerSaveMedicalRecord', {
      ...selectedItem,
      carCategories: selectedItemCheckedOptions.sort()
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
          window.open(`${props.url.download}?op=resellerMedicalRecord&idResellerMedicalRecord=${response.data.idResellerMedicalRecord}SID=${props.user.sessid}&variant=live`)
        }

        setIsLoaded(true);
      });
  };

  const handleDeleteMedicalRecord = () => {
    setIsLoaded(false);
    ajax('resellerMarkMedicalRecordAsDeleted', {
      idMedicalRecord: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeleteMedicalRecord = () => {
    setIsLoaded(false);
    ajax('resellerMarkMedicalRecordAsUndeleted', {
      idMedicalRecord: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Fise auto</Typography>
      <Typography variant='subtitle2'>Administrare fise auto.</Typography>
      <Typography variant='subtitle2'>Nu sunt afisate fisele auto care au fost deschise de catre SunMed.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.medicalRecords.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.medicalRecords.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' select
              disabled={Boolean(props.user.idPartner)}
              label='Partener'
              placeholder='Partener'
              name='idPartner'
              value={filter.idPartner}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toti partenerii</MenuItem>
              {data.partners.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.partner}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza fisele auto sterse'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.medicalRecords.length > 0 && data.medicalRecords.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.medicalRecords.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].partner !== a[i - 1].partner) &&
                <ListSubheader color='primary' disableSticky>{item.partner}</ListSubheader>
              }

              <ListItem dense className={classes.listItemDense}
                button={!!~props.user.permissions.indexOf('partnerMedicalRecordEdit')}
                selected={selectedItem && item.id === selectedItem.id}
                onClick={() => {
                  if (!!~props.user.permissions.indexOf('partnerMedicalRecordEdit')) {
                    setSelectedItem(item);
                    setSelectedItemOperation('editMedicalRecord');
                  }
                }}
              >
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography style={{fontWeight: 'bold'}}>{item.person}</Typography>
                  }
                  secondary={
                    <Box>
                      <Typography component='span' display='inline' color='textSecondary'>
                        Tip fisa:
                        <Typography display='inline' color='textPrimary'>{` ${item.service}`}</Typography>
                      </Typography>
                      {filter.showExtendedInfo &&
                        <Box>
                          <Typography color='textSecondary'>
                            {`Fisa necesara pentru: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.serviceType}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Categorii auto: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.carCategories}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`CNP: `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.cnp}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Creat de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                            {` la data de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                          </Typography>
                        </Box>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        {!!~props.user.permissions.indexOf('partnerMedicalRecordEdit') &&
          <MenuItem divider={false} onClick={handleItemMenuClick('editMedicalRecord')}>
            <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
            <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
          </MenuItem>
        }

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deleteMedicalRecord')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeleteMedicalRecord')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {isLoaded && !!~props.user.permissions.indexOf('partnerMedicalRecordAdd') &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setSelectedItem(emptyItem);
            setSelectedItemOperation('editMedicalRecord');
          }}
        >
          <AddIcon className={classes.fabIcon} />
          Adauga fisa auto
        </Fab>
      }

      {selectedItem && selectedItemOperation === 'editMedicalRecord' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted fullWidth
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editMedicalRecord'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{`Detalii fisa${selectedItem.person ? ` - ${selectedItem.person}`: ''}`}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              {selectedItem.existingPerson === null &&
                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <TextField margin='none' required autoComplete='off' inputProps={{maxLength: 13}}
                      label='CNP'
                      placeholder='CNP'
                      name='cnp'
                      value={selectedItem.personDetails.cnp}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Button fullWidth variant='contained' color='primary' size='large'
                      disabled={!RegExp(/^\d{13}$/, 'gmi').test(selectedItem.personDetails.cnp)}
                      onClick={handleSearchPerson}
                    >
                      Cauta
                    </Button>
                  </Grid>
                </Grid>
              }
              {selectedItem.idPerson &&
                <Box>
                  <Typography variant='subtitle2' color='primary'>{selectedItem.person}</Typography>
                  <Typography color='textPrimary'>{selectedItem.address}</Typography>
                  <Divider className={classes.divider} />
                  <TextField margin='none' required autoComplete='off' inputProps={{maxLength: 10}}
                      label='Telefon'
                      placeholder='Telefon'
                      name='phone'
                      value={selectedItem.phone}
                      onChange={handleSelectedItemChange()}
                    />
                  <Warning>CNP existent in baza de date, nu puteti actualiza decat numarul de telefon. Actualizarea se va face de catre angajatii SunMed in momentul in care persoana se va prezenta pentru eliberarea fisei auto.</Warning>
                </Box>
              }
              {selectedItem.existingPerson === false &&
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={4}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Nume'
                      placeholder='Nume'
                      name='surname'
                      value={selectedItem.personDetails.surname}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Prenume'
                      placeholder='Prenume'
                      name='name'
                      value={selectedItem.personDetails.name}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField margin='none' required autoComplete='off' inputProps={{maxLength: 13}}
                      disabled={true}
                      label='CNP'
                      placeholder='CNP'
                      name='cnp'
                      value={selectedItem.personDetails.cnp}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField margin='none' select
                      label='Judet nastere'
                      placeholder='Judet nastere'
                      name='birthIdCounty'
                      value={selectedItem.personDetails.birthIdCounty}
                      onChange={handleSelectedItemChange('personDetails')}
                    >
                      {data.counties.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.county}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Localitate nastere'
                      placeholder='Localitate nastere'
                      name='birthCity'
                      value={selectedItem.personDetails.birthCity}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField margin='none' required select
                      label='Judet domiciliu'
                      placeholder='Judet domiciliu'
                      name='addressIdCounty'
                      value={selectedItem.personDetails.addressIdCounty}
                      onChange={handleSelectedItemChange('personDetails')}
                    >
                      {data.counties.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.county}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Localitate domiciliu'
                      placeholder='Localitate domiciliu'
                      name='addressCity'
                      value={selectedItem.personDetails.addressCity}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={8} sm={4}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Strada'
                      placeholder='Strada'
                      name='addressStreet'
                      value={selectedItem.personDetails.addressStreet}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={4} sm={3}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Numar'
                      placeholder='Numar'
                      name='addressNumber'
                      value={selectedItem.personDetails.addressNumber}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField margin='none' autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Bloc'
                      placeholder='Bloc'
                      name='addressBuilding'
                      value={selectedItem.personDetails.addressBuilding}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField margin='none' autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Scara'
                      placeholder='Scara'
                      name='addressStaircase'
                      value={selectedItem.personDetails.addressStaircase}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField margin='none' autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Etaj'
                      placeholder='Etaj'
                      name='addressFloor'
                      value={selectedItem.personDetails.addressFloor}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <TextField margin='none' autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Ap.'
                      placeholder='Ap.'
                      name='addressApartment'
                      value={selectedItem.personDetails.addressApartment}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField margin='none' required select
                      label='Tip act de identitate'
                      placeholder='Tip act de identitate'
                      name='identityCardType'
                      value={selectedItem.personDetails.identityCardType}
                      onChange={handleSelectedItemChange('personDetails')}
                    >
                        <MenuItem value='BI'>Buletin de identitate</MenuItem>
                        <MenuItem value='CI'>Carte de identitate</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase, maxLength: 2}}
                      label='Serie act'
                      placeholder='Serie act'
                      name='identityCardSerial'
                      value={selectedItem.personDetails.identityCardSerial}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <TextField margin='none' required autoComplete='off' inputProps={{maxLength: 6}}
                      label='Numar act'
                      placeholder='Numar act'
                      name='identityCardNumber'
                      value={selectedItem.personDetails.identityCardNumber}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField margin='none' required autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Emis de'
                      placeholder='Emis de'
                      name='identityCardIssuedBy'
                      value={selectedItem.personDetails.identityCardIssuedBy}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField margin='none' required type='date' inputProps={{max: new Date().toISOString().split('T')[0]}}
                      label='Emis la'
                      placeholder='Emis la data'
                      name='identityCardIssuedAt'
                      value={selectedItem.personDetails.identityCardIssuedAt}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField margin='none' required autoComplete='off' inputProps={{maxLength: 10}}
                      label='Telefon'
                      placeholder='Telefon'
                      name='phone'
                      value={selectedItem.personDetails.phone}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <TextField margin='none' autoComplete='off' inputProps={{className: classes.textFieldUppercase}}
                      label='Email'
                      placeholder='Email'
                      name='email'
                      value={selectedItem.personDetails.email}
                      onChange={handleSelectedItemChange('personDetails')}
                    />
                  </Grid>
                </Grid>
              }
              {(selectedItem.idPerson || selectedItem.existingPerson === false) &&
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Divider className={classes.divider} />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField margin='none' required select
                      label='Tip fisa auto'
                      placeholder='Tip fisa auto'
                      name='idService'
                      value={selectedItem.idService}
                      onChange={handleSelectedItemChange()}
                    >
                      {data.services.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.service}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField margin='none' required select
                      label='Fisa necesara pentru'
                      placeholder='Fisa necesara pentru'
                      name='serviceType'
                      value={selectedItem.serviceType}
                      onChange={handleSelectedItemChange()}
                    >
                      {data.serviceTypes.map(option => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  {data.carCategories.filter(option => !!~option.idServices.indexOf(selectedItem.idService)).map(option =>
                    <Grid key={option.carCategory} item xs={3} sm={3} md={2}>
                      <FormControlLabel
                        control={
                          <Checkbox size='small' color='primary' style={{padding: '0px 8px'}}
                            checked={!!~selectedItemCheckedOptions.indexOf(option.carCategory)}
                            onChange={handleItemCheckedOptionsToggle(option.carCategory)}
                          />
                        }
                        label={
                          <Typography color='primary'>
                            {option.carCategory}
                          </Typography>
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <TextField margin='none' multiline rows={3}
                      label='Observatii'
                      placeholder='Observatii'
                      name='description'
                      value={selectedItem.description}
                      onChange={handleSelectedItemChange()}
                    />
                  </Grid>
                </Grid>
              }
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditMedicalRecord}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deleteMedicalRecord' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deleteMedicalRecord'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati aceasta fisa auto ca stearsa?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti aceasta fisa auto.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeleteMedicalRecord}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeleteMedicalRecord' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeleteMedicalRecord'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestei fise auto ca stearsa?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestei fise auto.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeleteMedicalRecord}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}